// ar_AE language file
// Generated from Feishu Bitable
// Total entries: 402

export default{
    "game_diamond": {
        "title": "معلومات عن جواهر اللعبة",
        "title0_title": "كيفية الحصول على جواهر اللعبة",
        "title0": {
            "txt1": "1. يمكنك الحصول عليها من مهام أو فعاليات محددة.",
            "txt2": "2. لا يمكن شراؤها عن طريق الشحن."
        },
        "title1_title": "استخدامات جواهر اللعبة",
        "title1": {
            "txt1": "1. تُستخدم فقط في الألعاب.",
            "txt2": "2. داخل اللعبة، جواهر اللعبة تعادل الألماس العادي ويمكن استخدامها مباشرة. الألماس الذي تربحه بجواهر اللعبة يُعتبر ألماسًا عاديًا.",
            "txt3": "3. يتم استخدام جواهر اللعبة أولاً.",
            "txt4": "4. يمكن استخدامها مع الجواهر العادية. مثال: لديك ٢٠٠ جوهرة لعبة و٨٠٠ عادية، سيتم استخدام جميعها عند الحاجة لـ١٠٠٠."
        },
        "title2_title": "صلاحية جواهر اللعبة",
        "title2": {
            "txt1": "1. صالحة لفترة محددة وسيتم سحبها بعد انتهاء الصلاحية."
        }
    },
    "guanxi_gift_rule_title": "وصف الهدية",
    "guanxi_gift_rule_1": "بعد إرسال هدية علاقة، يمكن للمستلم اختيار ما إذا كان يريد تشكيل علاقة معك. يمكن أن توجد علاقة واحدة فقط بين شخصين في نفس الوقت.",
    "guanxi_gift_rule_2": "يمكن لكل شخص أن يكون لديه ما يصل إلى 3 علاقات، ويمكن أن تكون أنواع العلاقات متشابهة.",
    "guanxi_gift_rule_3": "يمكنك إنهاء العلاقة بعد 24 ساعة من تشكيلها. بعد إنهاء العلاقة، يمكنك تكوين علاقة جديدة بعد 24 ساعة أخرى.",
    "not_exist": "غير موجود",
    "mbti_intro_title": "أوصاف MBTI",
    "mbti_intro_pers": "السمات الشخصية",
    "mbti_intro_love": "الصفات العاطفية",
    "mbti_intro_istj_pers": "شخصية المفتش",
    "mbti_intro_istj_feature": "جادون وهادئون، يركزون على التفاصيل والدقة، يفضلون الحياة المنظمة والمرتبة. موثوقون ومسؤولون، يتبعون القواعد والتقاليد.",
    "mbti_intro_istj_love": "في الحب، يعتبر الـ ISTJ شركاء أوفياء ومستقرين. يأخذون العلاقات بجدية، ويركزون على الالتزام والمسؤولية، ويظهرون اهتمامهم من خلال الأفعال بدلاً من الكلمات، ويحتاجون إلى الوقت لتكوين روابط عميقة.",
    "mbti_intro_isfj_pers": "شخصية الراعي",
    "mbti_intro_isfj_feature": "لطيفون، طيبون ومتعاطفون، يلبون احتياجات الآخرين بصبر واهتمام. يركزون على التفاصيل ويجيدون الاستماع والدعم.",
    "mbti_intro_isfj_love": "في العلاقات، يكون الـ ISFJ عميق الاهتمام، ويهتم بتفاصيل حياة الشريك، ويخلق جوًا دافئًا ومريحًا. غالبًا ما يكون تقليديًا ويأخذ وقتًا للالتزام، ولكنه شديد الولاء عند الالتزام.",
    "mbti_intro_infj_pers": "شخصية المهندس",
    "mbti_intro_infj_feature": "يتمتعون ببصيرة وإبداع، ولديهم فهم عميق للإنسانية والمستقبل. حياتهم الداخلية غنية وهم مفكرون وتحليليون.",
    "mbti_intro_infj_love": "يبحث الـ INFJ عن ارتباط عقلي وعاطفي مع الشريك ويقدرون المحادثات العميقة. لديهم مثالية عالية في الحب، وعندما يحبون يكونون مركزين ومخلصين.",
    "mbti_intro_intj_pers": "شخصية القائد",
    "mbti_intro_intj_feature": "منطقيون، هادئون وواثقون، لديهم مهارات تحليلية واتخاذ قرارات قوية، يقدرون المعرفة والحكمة ويطاردون أهدافهم بعزيمة.",
    "mbti_intro_intj_love": "في العلاقات، يتعامل الـ INTJ مع الحب بطريقة عقلانية، ويقدرون المعتقدات والأهداف المشتركة. رغم تحفظهم العاطفي، يعبرون عن اهتمامهم من خلال الأفعال المدروسة.",
    "mbti_intro_istp_pers": "شخصية الحرفي",
    "mbti_intro_istp_feature": "عملي، ملاحظ وتحليلي، يستمتع بالمهام اليدوية وحل المشكلات العملية، خاصة في المجالات الميكانيكية أو التقنية.",
    "mbti_intro_istp_love": "الـ ISTP عفويون وأحرار في العلاقات، يستمتعون باللحظة مع شركائهم ويشاركون ملذات الحياة دون قيود.",
    "mbti_intro_isfp_pers": "شخصية الفنان",
    "mbti_intro_isfp_feature": "حساسون، لطيفون وفنيون، يفضلون التجارب العاطفية والحسية، ويعبرون عن أنفسهم غالباً من خلال الأشكال الإبداعية.",
    "mbti_intro_isfp_love": "في العلاقات، يكون الـ ISFP رومانسيًا ومهتمًا، ويجيد خلق أجواء ساحرة وغالباً ما يُسعد شريكه بالمفاجآت. قد يكون عاطفيًا ويحتاج إلى شريك يفهمه ويدعمه.",
    "mbti_intro_infp_pers": "شخصية الوسيط",
    "mbti_intro_infp_feature": "مثاليون، طيبون ومتعاطفون، لديهم حياة داخلية غنية وفهم عميق للطبيعة البشرية، ويقدرون التناغم والجمال.",
    "mbti_intro_infp_love": "يستثمر الـ INFP بعمق في العلاقات ويبحثون عن روابط عاطفية قوية. يقدرون التبادل العاطفي ويشتركون في رؤية إيجابية عن الحب.",
    "mbti_intro_intp_pers": "شخصية المفكر",
    "mbti_intro_intp_feature": "تحليليون وفضوليون، لديهم رغبة قوية في المعرفة واستكشاف المناطق المجهولة سعياً وراء الحقيقة.",
    "mbti_intro_intp_love": "في العلاقات، يتعامل الـ INTP بطريقة منطقية ويركز على التوافق الفكري والعاطفي. قد يكونون متحفظين في التعبير عن مشاعرهم، لكنهم يستخدمون النقاش لتعزيز التفاهم المتبادل.",
    "mbti_intro_estp_pers": "شخصية الريادي",
    "mbti_intro_estp_feature": "نشيطون، منفتحون ومغامرون، يستمتعون بالتفاعل الاجتماعي وأخذ المخاطر ويقتنصون الفرص بنشاط.",
    "mbti_intro_estp_love": "في العلاقات، يتميز الـ ESTP بالحيوية والشغف، ويحبون استكشاف تجارب جديدة مع شركائهم. يتحدثون بصراحة ويعبرون عن أفكارهم ومشاعرهم دون تحفظ.",
    "mbti_intro_esfp_pers": "شخصية المؤدي",
    "mbti_intro_esfp_feature": "منفتحون، متفائلون ومعبرون، يستمتعون بالاختلاط والترفيه ويضفون الطاقة والحماس.",
    "mbti_intro_esfp_love": "في الحب، يكون الـ ESFP شركاء مفعمين بالحيوية، يستمتعون بالأنشطة الاجتماعية المشتركة، ويعطون الأولوية للمشاعر والتجارب الحالية، مما يجلب الفرح والحماس لشركائهم.",
    "mbti_intro_enfp_pers": "شخصية الداعم",
    "mbti_intro_enfp_feature": "مبدعون، مليئون بالطاقة ودافئون، يحبون التفاعل مع الآخرين ويفهمون مشاعرهم بعمق.",
    "mbti_intro_enfp_love": "يعتبر الـ ENFP كأشعة الشمس في العلاقات، يجلبون الدفء والفرح لشركائهم. مليئون بالرومانسية، يعبرون عن حبهم بنشاط ويتطلعون لصنع ذكريات جميلة معًا.",
    "mbti_intro_entp_pers": "شخصية المناظر",
    "mbti_intro_entp_feature": "أذكياء، لامعون وفضوليون، يستمتعون بالمناظرات واستكشاف الأفكار والمواضيع الجديدة.",
    "mbti_intro_entp_love": "يشارك الـ ENTP في نقاشات عميقة ومناظرات مع شركائهم، ويستمتعون بالتحديات والنمو الفكري في الحب. غالباً ما يكونون مرحين ويضفون حس الفكاهة للعلاقة.",
    "mbti_intro_estj_pers": "شخصية المنفذ",
    "mbti_intro_estj_feature": "عملي، حاسم واثق، يمتلكون مهارات تنظيم وقيادة قوية، ويعطون الأولوية للكفاءة والنتائج.",
    "mbti_intro_estj_love": "في الحب، يكون الـ ESTJ حازمًا ومصممًا، يتابع اهتماماته بنشاط ويخطط للمستقبل. يظهرون العاطفة من خلال الدعم العملي والأفعال.",
    "mbti_intro_esfj_pers": "شخصية المستشار",
    "mbti_intro_esfj_feature": "ودودون ودافئون، اجتماعيون ويهتمون بالآخرين، يقدرون التقاليد وروابط الأسرة.",
    "mbti_intro_esfj_love": "يكون الـ ESFJ شركاء منتبهين وحنونين، يخلقون بيئة رومانسية دافئة ومنسجمة. غالباً ما يكونون تقليديين، ويقدرون عادات المواعدة المألوفة وموافقة العائلة.",
    "mbti_intro_enfj_pers": "شخصية القائد",
    "mbti_intro_enfj_feature": "كاريزميون وواثقون، يتواصلون بسهولة ويفهمون ويقودون الآخرين بفاعلية.",
    "mbti_intro_enfj_love": "الـ ENFJ شركاء متحمسون ورومانسيون، يعبرون عن حبهم بصراحة ويخلقون جواً دافئاً. يقدرون التبادل العاطفي ويهدفون لتكوين رابطة عميقة مع شركائهم.",
    "mbti_intro_entj_pers": "شخصية المدير التنفيذي",
    "mbti_intro_entj_feature": "منطقيون، واثقون وطموحون، يتمتعون بمهارات قوية في القيادة واتخاذ القرار، يقدرون التميز والنجاح، ويضعون معايير عالية لأنفسهم وللآخرين.",
    "mbti_intro_entj_love": "في الحب، يركز الـ ENTJ على الأهداف، ويختارون شركاء يشتركون في نفس العقلية ويدعمون النمو المتبادل. يعطون الأولوية للكفاءة والطموحات المشتركة، ويعمقون العلاقات من خلال الأهداف المشتركة.",
    "expressProposalWall": "مكان الحب",
    "expressHowTo": "كيفية نشر كلمات على مكان الحب",
    "expressSend": "أرسل هدية الحب إلى حبيبك وسيظهر نصك الذي يعبر عن الحب على مكان الحب.",
    "expressSend1": "1.اضغط على \"قول حبك\"، يمكنك الانتقال إلى الحفلة واختيار المستخدم لرسائل من القلب.",
    "expressSend2": "2.اختر الهدية وأدخل الكلمات التي تريد أن تقول لها/ له على البطاقة.",
    "expressSend3": "3.اضغط لإرسال الهدية وستظهر بطاقة الحب الخاصة بك على مكان الحب.",
    "expressDifferent": "أنواع مختلفة من هدايا الحب",
    "expressWeHave": "لدينا 4 أنواع من هدايا الحب حسب كما يلي.",
    "expressWeHave1": "1.بطاقة هدية الحب الأساسي: خلفية ملونة بسيطة.",
    "expressWeHave2": "2. بطاقة هدية الحب الديكور: خلفية ملونة مزخرفة.",
    "expressWeHave3": "3.بطاقة هدية الحب الفاخر: خلفية مزخرفة بتأثير فاخر.",
    "expressWeHave4": "4.بطاقة هدايا الحب الحقيقي: خلفية مزخرفة ذات تأثير فاخر، مع شريط الاعلان الرائع على مستوى الخادم.",
    "expressProposal": "نطاق عرض بطاقة الحب",
    "expressProposal1": "1.مكان الحب في الغرفة. (اضغط على الشريط الموجود أعلى الهدايا الحب)",
    "expressProposal2": "2.مكان الحب بجانب صفحة اللحظة.",
    "diamondDrop1": "1.عندما يرسل المستخدم هدايا مجموعها أكثر من 50000 ألماسة مرة واحدة في الغرفة (يتم حساب الهدايا المحظوظة= سعر الماس الخاص بها*0.1)، يظهر صندوق ألماس في الغرفة ويمكن لأي شخص فتحه للحصول على الألماس.",
    "diamondDrop2": "2.كل صندوق يحتوي على عد تنازلي لمدة دقيقة واحدة قبل أن يتم فتحه.",
    "diamondDrop3": "3.الألماس في كل صندوق محدود؛ بمجرد انتهاء العد التنازلي، لا يمكنك الحصول على الألماس من ذلك الصندوق بعد الآن.",
    "diamondDrop4": "4.بعد إغلاق الصندوق، يمكنك النقر لرؤية عدد الألماسات التي حصلت عليها منه.",
    "baoxaingxianding": "صندوق الكنز المحدود",
    "cancelAccount": {
        "accountRecoveryContent": "خلال فترة الاسترداد، يمكنك تسجيل الدخول مرة أخرى باستخدام طريقتك السابقة واختيار استعادة حسابك. بمجرد استعادة الحساب، ستستعيد جميع رسائل الحساب والمستويات والألماس.",
        "accountRecoveryTitle": "استعادة الحساب:",
        "confirmCancellation": "هل أنت متأكد من أنك تريد الحذف؟",
        "convalescenceContent": "بعد تقديم طلب الحذف، سيتم تعطيل حسابك مؤقتًا لمدة 30 يومًا. خلال هذا الوقت، سيتم الاحتفاظ بجميع معلومات حسابك والمستويات والألماس، مما يسمح بالاسترداد بسهولة إذا غيرت رأيك.",
        "convalescenceTitle": "فترة الاسترداد:",
        "finalContent": "إذا لم تختر استعادة حسابك بنهاية فترة الاسترداد (31 يومًا من طلب الحذف)، سيتم حذف حسابك وجميع البيانات المرتبطة به بشكل دائم. يرجى ملاحظة أنه بمجرد الحذف، لا يمكن استرداد حسابك وبياناتك.",
        "finalTitle": "الحذف النهائي:",
        "reserveContent": "خلال فترة الاسترداد، سنحمي بيانات حسابك لضمان عدم فقدانها أو تلفها.",
        "reserveTitle": "الاحتفاظ بالبيانات:",
        "statementContent": "طلب الحذف: بعد تقديم طلب حذف الحساب، سيدخل حسابك فترة \"استرداد\" مدتها 30 يومًا. خلال هذا الوقت، يمكنك اختيار استعادة حسابك في أي وقت. إذا كنت جزءًا من وكالة، فلن يكون حذف الحساب ممكنًا.",
        "statementTitle": "إشعار حذف الحساب:",
        "userContent": "شكرًا لاستخدامك خدماتنا. نحن نتفهم أنه قد تحتاج أحيانًا إلى حذف حسابك. لضمان أن يكون قرارك مدروسًا جيدًا ولتوفير فرصة لإعادة النظر، نوضح هنا عملية حذف الحساب والشروط ذات الصلة.",
        "userTitle": "عزيزي المستخدم:"
    },
    "Countdown": "العد التنازلي",
    "Endactivity": "انتهى الحدث",
    "eventDetails": "تفاصيل الحدث",
    "eventGifts": "هدايا الحدث",
    "eventList": "قائمة المتصدرين في الحدث",
    "eventReward": "مكافآت الحدث",
    "eventRewards": {
        "player": "اللاعبين النشطين يوميا",
        "proportion": "معدل عائد الجائزة",
        "title": "جوائز الحدث",
        "txt1": "1. يتم حساب بيانات اليوم السابق يوميًا في الساعة 00:00 (UTC+8).",
        "txt2": "2. تُمنح الجوائز بناءً على عدد المشاركين والماس الفعلي الذي تم إنفاقه في الغرفة (رهانات المستخدم ناقص أرباح المستخدم).",
        "txt3": "3. يتم حساب بيانات الأسبوع السابق كل يوم اثنين في الساعة 00:00 (UTC+8)، ويتم توزيع المكافآت في غضون 3 أيام.",
        "txt4": "4. معدل عائد الجائزة:",
        "txt5": "5. تعريف اللاعب النشط: اللاعب الذي يراهن بأكثر من 1000 ماسة في اليوم."
    },
    "EventRules": "قواعد الحدث",
    "Eventtime": "وقت الحدث",
    "guild": {
        "guild_certification01": "تحقق الوكالة",
        "guild_certification02": "مرحبًا بالوكالة",
        "guild_certification03": "متطلبات التوظيف",
        "guild_certification04": [
            "أكمال التوقيع مع 10 مضيفين واستقرارهم خلال أسبوع واحد",
            "قادر على تقديم هوية قائد الوكالة والمستندات الأخرى باسم حقيقي",
            "تقديم ملف تعريفي للوكالة، تقديم الفريق، معلومات المذيعين، قواعد أرباح المذيعين، إلخ."
        ],
        "guild_certification05": "إذا كنت تفي بالمتطلبات المذكورة أعلاه، أرسل معلوماتك إلى البريد الإلكتروني الرسمي: billionairepte@gmail.comبمجرد الموافقة، سيتصل بك أحد الموظفين.",
        "guild_certification06": "تم النسخ إلى الحافظة",
        "guild_certification07": "جهة الاتصال للاستفسار",
        "guild_certification08": "نسخ",
        "guild_certification09": "معلومات العضوية",
        "guild_certification10": [
            {
                "title": "1. قواعد العضوية",
                "value": [
                    "يجب أن يوافق المتقدمون مع زعيم الوكالة لبدء طلب العضوية على المنصة. بمجرد موافقة الزعيم، يصبحون مذيعين موقعين، يساهمون في الوكالة."
                ]
            },
            {
                "title": "2. قواعد الاستقالة",
                "value": [
                    "لمغادرة الوكالة بعد الانضمام، يحتاج المذيع إلى موافقة قائد الوكالة. انقر على \\\"مغادرة الوكالة\\\" في صفحة الملف الشخصي للوكالة. يجب على قائد الوكالة النقر على \"موافق على المغادرة\" ثم يغادر العضو الوكالة.",
                    "بعد نجاح الانسحاب، يمكنك التقدم للانضمام إلى وكالة أخرى."
                ]
            }
        ],
        "guild_certification11": "معلومات الوكالة",
        "guild_certification12": [
            {
                "title": "دخل الوكالة",
                "value": [
                    "يتلقى المستخدمون والمذيعون في غرف العائلة الهدايا، مما يولد مساهمات للوكالة.",
                    "تحدث هجمات الرئيس في غرف العائلة.",
                    "المذيعون الموقعون مع الوكالة ينشئون غرف CP، وتلقي الهدايا يولد مساهمات للوكالة. (لا يمكن للمذيعين غير الموقعين إنشاء غرف CP وتوليد مساهمات للعائلة بعد الانضمام إلى العائلة.)"
                ]
            }
        ],
        "InvitationCodeTitle": "رمز الدعوة",
        "invite_rules_intriduction": "قواعد الدعوة",
        "invite_rules_intriduction_content": [
            "يمكن للمذيعين التقدم للانضمام إلى وكالتك ويصبحون مذيعين عن طريق إدخال رمز الدعوة أثناء التسجيل.",
            "المذيعون الذين لم يدخلوا رمز الدعوة أثناء التسجيل يمكنهم التقدم للانضمام إلى عائلتك من خلال صفحة العائلة، ثم التقدم ليصبحوا مذيعين."
        ]
    },
    "legend": {
        "title": "فبراير الأسطوري"
    },
    "officialMember": "الموظفين الرسميين",
    "prettyNumber": {
        "text": "Ⅰ. جمع معرف خاص",
        "text1": "بعد الوصول إلى المستوى النبيل 3 أو أعلى، يمكنك الحصول على معرف خاص يتوافق مع مستواك.",
        "text2": "يمكن للنبلاء ذوي المستوى الأعلى الحصول على معرف خاص بمستوى أقل. على سبيل المثال، يمكن للنبلاء 6 الحصول على معرف خاص من المستوى 3.",
        "text3": "عندما تنتهي حالة النبلاء الخاصة بك، يصبح المعرف الخاص غير متاح أيضًا. تحتاج إلى إعادة تفعيل نبلك للاستمرار في استخدام المعرف الخاص.",
        "text5": "بمجرد الحصول على معرف خاص، لا يمكنك استبداله بمعرف آخر من نفس المستوى أو مستوى أقل.",
        "text6": "إذا حققت مستوى نبيلاً أعلى أثناء استخدام معرف خاص، يمكنك التبديل فوراً إلى معرف خاص بمستوى أعلى، وسيعود المعرف الأصلي إلى المتجر.",
        "text7": "على سبيل المثال، لا يمكن لمستخدم نوبل 4 الذي يطلب في البداية معرف نوبل 4 خاص ثم يقوم بالترقية إلى نوبل 6 التبديل إلى معرف نوبل 4 أو أقل، ولكنه يمكنه فوراً المطالبة بمعرف نوبل 6 خاص.",
        "title": "توضيح",
        "title1": "انتهاء صلاحية الأي دي الخاص",
        "title2": "Ⅲ. استبدال الأي دي الخاص"
    },
    "reception": {
        "reception01": "شرح قائمة المتصدرين للهدايا",
        "reception02": [
            {
                "title": "ما هي قائمة المتصدرين للهدايا في الغرفة؟",
                "value": [
                    "قائمة المتصدرين للهدايا في الغرفة هي ترتيب لحظي للهدايا التي تم تلقيها في الغرفة",
                    "عدد الهدايا في الغرفة = عدد هدايا الألماس"
                ]
            },
            {
                "title": "كيف يتم ترتيب قائمة المتصدرين للهدايا في الغرفة؟",
                "value": [
                    "الترتيب يتم تحديده بناءً على إجمالي دخل جميع الغرف، ويتم حسابه بشكل شامل",
                    "قائمة المتصدرين بالساعة: يتم إعادة ضبطها كل ساعة عند UMT+8",
                    "قائمة المتصدرين اليومية: يتم إعادة ضبطها في 00:00 UMT+8 كل يوم"
                ]
            },
            {
                "title": "يتم بث المركز الأول في قائمة المتصدرين بالساعة على مستوى الخادم",
                "value": [
                    "يتم الإعلان عن الغرفة التي تحتل المركز الأول في قائمة المتصدرين بالساعة على مستوى جميع غرف الخادم"
                ]
            }
        ]
    },
    "roomParty": {
        "back": "رجوع",
        "event_rule": "<p>1. قائمة المتصدرين لمدة الوقت: يتتبع إجمالي الوقت الذي يقضيه المستخدمون في جميع مواقع الميكروفون بالغرفة خلال الحدث. أعلى 3 مساهمين في أعلى 3 غرف سيحصلون على مكافآت.</p><p>2. قائمة السخاء: تتتبع العدد الإجمالي للألماس المستلم في الغرفة خلال الحدث. أعلى 3 مستهلكين للألماس في أعلى 3 غرف سيحصلون على مكافآت.</p><p>3. هذا الحدث هو حدث أسبوعي، حيث يتم إعادة تعيين القائمة وإعادة حسابها كل أسبوع.</p>",
        "last_week": "الأسبوع الماضي",
        "last_week_rank": "تفاصيل قائمة المتصدرين الأسبوع الماضي",
        "reward": "المكافآت",
        "rich_rank": "قائمة هدايا الغرفة",
        "rule": "القواعد",
        "rule_reward": "القواعد والمكافآت",
        "time_rank": "قائمة مدة الوقت",
        "title": "غرفة العائلة",
        "top1": "توب 1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_1_name": "إطار الصورة 14 يومًا",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/mount/thunder_armor.png?t=1666610955",
        "top1_pictures_2_name": "دخولية 14 يوماً",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_3_name": "إطار الصورة 14 يومًا",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_4_name": "إطار الصورة 7 يومًا",
        "top2": "توب 2",
        "top3": "توب 3"
    },
    "TopUpRewards": "مكافآت الشحن",
    "treasure_chest": {
        "title": "تعليمات هدايا صندوق الكنز",
        "value1": "هناك ثلاثة أنواع من صناديق الكنز: خشبي، فضي، وذهبي.",
        "value2": "عندما تفتح صندوق الكنز، ستحصل على هدية عشوائية من الصندوق وتقوم بإرسالها.",
        "value3": "المرسل يكسب نقاط خبرة بناءً على الألماس المستهلك، بينما يتلقى المستلم عملات ونقاط جاذبية بناءً على قيمة الهدية من الصندوق.",
        "value4": "صندوق خشبي، بسعر 1500 ألماس، يحتوي على الهدايا التالية:",
        "value5": "صندوق فضي، بسعر 7500 ألماس، يحتوي على الهدايا التالية:",
        "value6": "صندوق ذهبي، بسعر 25000 ألماس، يحتوي على الهدايا التالية:",
        "value7": "هدايا صندوق الكنز هي فقط للترفيه والتفاعل الاجتماعي. أي إجراءات تؤثر على العدالة أو تستغل أخطاء المنتج سيتم حظرها. إذا تم اكتشاف ذلك، ستقوم المنصة بحظر الحساب وتحتفظ بالحق في اتخاذ الإجراءات القانونية."
    },
    "treasure_name": {
        "name1": "صندوق خشبي",
        "name2": "صندوق فضي",
        "name3": "صندوق ذهبي",
        "name4": "احتمالية"
    },
    "Value": "القيمة:",
    "Webname": {
        "addUid": "إضافة UID",
        "balance": "الرصيد:",
        "Confirm": "تأكيد",
        "err_uid": "UID غير صالح، يرجى إدخال مرة أخرى",
        "lang": "اختر اللغة",
        "Query": "بحث",
        "recharge": "مركز إعادة الشحن",
        "Recharge": "إعادة شحن",
        "self": "قناة",
        "uid": "تغيير UID",
        "uuserName": "لقب:",
        "Withdrawal": "سحب"
    },
    "Weekly_Cp": {
        "7days": "7 أيام",
        "back": "رد : .",
        "countdown": "العد التنازلي لهذا الأسبوع",
        "day": "أيام .",
        "diamonds": "https://image.pocketliveapp.com/image/activity/New%20Folder/diamonds.png",
        "event_rule": "<p>1.يتم حساب ترتيب على حسب مجموع هدايا النشاط التي المستخدم يمنحها الى حبيبتة (المضيفة) ، 1 ماسة =1 قيمة النشاط ، وسيحصل الثلاث الأوائل على مكافأة النشاط بعد انتهاء وقت الترتيب </p><p>2. هذا النشاط نشاط اسبوعي ؛ </p><p>3. سيتم توزيع مكافآت النشاط في غضون 3 أيام عمل بعد انتهاءالنشاط.</p>",
        "gift": "هدايا الحدث",
        "hour": "ساعة",
        "last_week": "الأسبوع الماضي",
        "last_week_rank": "قائمة الأسبوع الماضي",
        "minute": "دقيقة",
        "pocketcoins": "https://image.pocketliveapp.com/image/activity/New%20Folder/coins.png",
        "reward": "المكافآت",
        "rule": "القواعد",
        "rule_reward": "القواعد والمكافآت",
        "seconds": "ثواني",
        "title": "توأم الروح",
        "top1": "الأول",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top1_pictures_1_name": "إطار الصورة الرمزية لنجم الأسبوع",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top1_pictures_2_name": "إطار الصورة الرمزية لأفضل دعم",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/2011_cloth_female.png?t=1678879041",
        "top1_pictures_34_name": "زي نجم الأسبوع",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/2010_suit_male.png?t=1678879038",
        "top2": "الترتيب الثاني",
        "top2_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top2_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top3": "الترتيب الثالث",
        "top3_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top3_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top46": "أفضل ٤-٦",
        "top710": "أفضل ٧-١٠"
    },
    "Withdrawal": "تعليمات السحب",
    "withdrawalInstructions": {
        "text1": "ميزة السحب متاحة حاليًا في بلدان محددة فقط.",
        "text2": "قد يختلف وقت معالجة السحب حسب القناة المستخدمة.",
        "text3": "قد يكون المبلغ الفعلي المستلم أقل قليلاً من المبلغ المعروض بسبب تقلبات أسعار الصرف والرسوم.",
        "text4": "يمكنك السحب مرة واحدة فقط في اليوم.",
        "text5": "إذا واجهت أي مشاكل، يرجى الاتصال بنا."
    },
    "withdrawalLogin": {
        "accountId": "معرف حساب Pix",
        "accountIdTips": "",
        "accountIdtsa": "معرف حساب Pix لا يمكن أن يكون فارغًا",
        "accountType": "نوع حساب Pix",
        "code": "رمز التحقق:",
        "Confirm": "تأكيد",
        "documentId": "رقم الهوية الشخصية",
        "documentIdTips": "",
        "documentIdtsa": "نوع الهوية لا يمكن أن يكون فارغًا",
        "documentType": "نوع الهوية",
        "getAccount": "الحصول على الحساب",
        "getUserId": "يرجى إدخال معرف المستخدم",
        "incorrectAccount": "الحساب غير صحيح",
        "login": "تسجيل الدخول",
        "loginSuccessful": "تم تسجيل الدخول بنجاح",
        "name": "اسم مستخدم Pix",
        "nameTips": "",
        "nametsa": "يجب أن يتراوح الطول بين 5 و 100 حرفًا",
        "officialGroup": "إذا كان لديك أي أسئلة، يرجى الاتصال بالدعم الرسمي",
        "pocket": "رصيد Pocket Coin",
        "Pocket": "رصيد Pocket Coin غير كافٍ",
        "Send": "إرسال",
        "text": "سيتم إرسال رمز التحقق داخل التطبيق",
        "title": "سحب الأرباح",
        "title2": "تفاصيل السحب",
        "user_id": "معرف الحساب:",
        "Whatsapp": "حساب Whatsapp غير صحيح",
        "WhatsappTips": "",
        "applicationTime": "تاريخ الطلب",
        "amount": "مبلغ السحب",
        "success": "نجاح",
        "applicationSuccess": "تم تقديم الطلب"
    },
    "top1AnchorRewards": "مكافات المضيف توب ١",
    "top2_3AnchorRewards": "مكافآت توب ٢ و توب ٣ للمضيفين",
    "top4_10AnchorRewards": "مكافآت توب ٤ -توب ١٠  للمضيفين",
    "top1Icon7day": "إطار الصورة الرمزية لمدة سبعة أيام",
    "top1_2Icon7day": "تأثير الدخول لمدة سبعة أيام",
    "top3Icon7day": "إطار الصورة الرمزية لمدة سبعة أيام",
    "top1VIPRewards": "مكافآت توب ١ في الشحن",
    "top2_3VIPRewards": "مكافآت توب ٢ - توب ٣ في الشحن",
    "top4_10VIPRewards": "مكافآت توب ٤- توب ١٠ في الشحن",
    "relastionship": {
        "des": [
            "",
            "1. بعد تقديم هدية العلاقة، يمكن للطرف الآخر اختيار ما إذا كان يرغب في إقامة علاقة معك. لا يمكن أن توجد سوى علاقة واحدة بين شخصين.",
            "2. خلال 7 أيام تقويمية (UTC+3) بعد إنشاء العلاقة، لن تنخفض قيمة القرب. بعد فترة الحماية، إذا لم تزداد القرب بمقدار 50 درجة في يوم واحد، فسوف تنخفض بنسبة 10٪ في منتصف الليل في اليوم التالي (الحد الأدنى للانخفاض هو 1). عندما تصل القرب إلى 0، سيتم فك الارتباط في منتصف الليل في اليوم التالي. إذا لم تزد القرب بمقدار 50 درجة لمدة 10 أيام متتالية، فستنتهي العلاقة تلقائيًا عند منتصف الليل.",
            "3. يمكنك إنهاء العلاقة بعد 24 ساعة من إنشائها. بعد إنهائها، يمكنك إعادة إقامة العلاقة بعد 24 ساعة.",
            "4. لكل شخص 3 مواقع علاقة افتراضية. يمكنك إنفاق الماس لشراء المزيد، كل موقع يكلف 99,999 ماسة، ويمكنك شراء ما يصل إلى 10. يمكنك أيضًا زيادة المواقع برفع مستوى VIP الخاص بك.",
            "مستوى VIP",
            "إجمالي خانات العلاقات القابلة للتوسيع"
        ]
    },
    "gift_album_des1": "إرسال الهدايا أعلاه يمكن أن يساعده/ساعدها في إضاءة ألبوم الأسبوع - \"جولة عالمية\" والحصول على مكافآت.",
    "gift_album_des2": "إرسال الهدايا أعلاه يمكن أن يساعده/ساعدها في إضاءة الألبوم الدائم - \"محور الاهتمام\" والحصول على مكافآت.",
    "gift_album_des3": "إرسال الهدايا أعلاه يمكن أن يساعده/ساعدها في إضاءة الألبوم الدائم - \"حماية SVIP\" والحصول على مكافآت.",
    "gift_album_des4": "إرسال الهدايا أعلاه يمكن أن يساعده/ساعدها في إضاءة الألبوم الدائم - \"حفل زفاف الأحلام\" والحصول على مكافآت.",
    "gift_album_des5": "انتقل إلى [الملف الشخصي] - [حائط الهدايا] - [الألبوم] لعرض التفاصيل",
    "gift_harifata": "برج خليفة",
    "gift_sailing_hotel": "برج العرب",
    "gift_mosque": "المسجد الكبير",
    "gift_abatta": "برج اباتي",
    "gift_sphinx": "أبو الهول",
    "svip_gift_1": "SVIP1",
    "svip_gift_2": "SVIP2",
    "svip_gift_3": "SVIP3",
    "svip_gift_4": "SVIP4",
    "svip_gift_5": "SVIP5",
    "svip_gift_6": "SVIP6",
    "gift_conf_lv1": "نبض الحب",
    "gift_conf_lv2": "مغرم بالحب",
    "gift_conf_lv3": "حب للابد",
    "gift_conf_lv4": "لا احد سواك",
    "gift_habibi": "الاخوة",
    "gift_bestie": "الأخوات",
    "gift_couple": "CP",
    "gift_confidant": "رفيق",
    "weding_gift_kiss": "قبلة",
    "weding_gift_ring": "خاتم",
    "weding_gift_proposal": "طلب الزواج",
    "weding_gift_castle": "قلعة",
    "weding_gift_wedding_dress": "فستان زفاف",
    "weding_gift_wedding": "زفاف",
    "gift_album_des6": "القواعد",
    "guild_can_with": "",
    "guild_with_ing": "",
    "guild_self_withdraw": "",
    "guild_transfer_to_leader": "",
    "guild_salary_to_reseller": "",
    "guild_convert_to_diamond": "",
    "guild_platform_settlement": "",
    "guild_withdrawal_records": "",
    "guild_current_withdrawable_pcoin": "",
    "guild_transfer_pcoin_amount": "",
    "guild_all": "",
    "guild_read_before_withdraw": "",
    "guild_withdraw_note_1": "",
    "guild_withdraw_note_2": "",
    "guild_min_withdraw_amount": "",
    "guild_withdraw_note_4": "",
    "guild_submit_application": "",
    "guild_withdraw_below_min": "",
    "guild_confirm_submit_application": "",
    "guild_freeze_notice": "",
    "guild_communicate_with_leader": "",
    "guild_cancel": "",
    "guild_confirm": "",
    "guild_withdrawal_method": "",
    "guild_leader_withdraw": "",
    "guild_apply_time": "",
    "guild_process_time": "",
    "guild_rejection_reason": "",
    "guild_amount_refunded": "",
    "guild_status_pending": "",
    "guild_status_completed": "",
    "guild_status_rejected": "",
    "guild_show_last_3_months": "",
    "guild_withdrawal_question": "",
    "guild_contact_customer_service": "",
    "guild_certified_reseller": "",
    "guild_not_reseller_cannot_transfer": "",
    "guild_current_withdrawable": "",
    "guild_transfer_amount": "",
    "guild_estimated_arrival": "",
    "guild_read_before_operation": "",
    "guild_transfer_note_1": "",
    "guild_transfer_note_2": "",
    "guild_confirm_transfer": "",
    "guild_confirm_submit_transfer": "",
    "guild_deduct_pcoin_receive_diamond": "",
    "guild_communicate_with_reseller": "",
    "guild_operation_success": "",
    "guild_exchange_diamond": "",
    "guild_current_exchangeable_pcoin": "",
    "guild_exchange": "",
    "guild_exchange_success": "",
    "guild_settlement_pcoin_amount": "",
    "guild_settlement_note_1": "",
    "guild_settlement_note_2": "",
    "guild_settlement_min_amount": "",
    "guild_application_submitted": "",
    "guild_deduct_pcoin": "",
    "guild_contact_service": ""
}
